import { EnhancedSeoHead, useResponseStatus } from "@appcaire/shared/seo";
import { Loader2, TriangleAlert } from "lucide-react";
import { SITE_ORIGIN } from "../lib/site";

export function PageLoading({
  label = "Hämtar aktuell information…",
}: {
  label?: string;
}) {
  return (
    <section
      className="mx-auto flex min-h-[45vh] max-w-6xl items-center justify-center px-4 py-16"
      aria-live="polite"
    >
      <div className="text-center text-muted-foreground">
        <Loader2
          className="mx-auto h-10 w-10 animate-spin text-brand-primary motion-reduce:animate-none"
          aria-hidden="true"
        />
        <p className="mt-4 text-base">{label}</p>
      </div>
    </section>
  );
}

export function DataUnavailable({
  path,
  title = "Informationen är tillfälligt otillgänglig",
}: {
  path: string;
  title?: string;
}) {
  useResponseStatus(503);
  return (
    <>
      <EnhancedSeoHead
        siteKey="stockholm"
        title={`${title} | Stockholms Hemtjänstguide`}
        description="Vi kunde inte hämta aktuell information från statistikservern. Försök igen om en stund."
        canonicalUrl={`${SITE_ORIGIN}${path}`}
        indexable={false}
      />
      <section
        role="alert"
        className="mx-auto min-h-[55vh] max-w-2xl px-4 py-20"
      >
        <TriangleAlert
          className="h-11 w-11 text-brand-secondary"
          aria-hidden="true"
        />
        <h1 className="mt-5 font-[var(--font-editorial)] text-3xl font-bold text-foreground md:text-4xl">
          {title}
        </h1>
        <p className="mt-4 text-lg leading-8 text-muted-foreground">
          Vi kunde inte hämta den aktuella utförarlistan. För att inte visa
          inaktuella eller ofullständiga uppgifter publicerar vi inte en
          reservlista här.
        </p>
        <a
          href={path}
          className="mt-7 inline-flex min-h-11 items-center rounded-xl bg-brand-primary px-5 py-3 font-semibold text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-primary focus-visible:ring-offset-2"
        >
          Försök igen
        </a>
      </section>
    </>
  );
}
